export function stringParam(params: unknown, key: string): string {
  if (typeof params !== 'object' || params === null) return '';

  const value = (params as Record<string, unknown>)[key];
  return typeof value === 'string' ? value : '';
}
